import Vue from 'vue'
import axios from 'axios'

const $ = kendo.jQuery
const ee = new Vue()
const url = {
  action: (action, controller) => `/api/list/${controller}/${action}`,
}

function createControls(options, invalidForecastDates, nbPeriods, minDate) {
  let windowHtml = $('<div id="forecastDateWindow" style="padding-right: 0px;"></div>').appendTo(
    document.body,
  )
  let kendoWindow = windowHtml
    .kendoWindow({
      orientation: 'vertical',
      width: '470px',
      visible: false,
      resizable: false,
      modal: true,
      height: '150px',
      title: 'Create new Forecast',
      actions: ['Close'],
      close: function() {
        windowHtml.remove()
      },
    })
    .data('kendoWindow')
  let html =
    '<div id="forecastDateToolbar" style="text-align:center;" class = "row"> </div> <div id="startDateToolbar" style="text-align:center;" class = "row"></div>'
  let startDateDropDownList

  windowHtml.empty().append(html)
  $('#forecastDateToolbar')
    .css('width', '99.85%')
    .kendoToolBar({
      items: [
        {
          template: "<h5 style='font-weight:bold; padding-right:10px;'>Forecast Date: </h5>",
        },
        {
          template: "<input id='forecastDatePicker'/>",
        },
        {
          template: "<span id='addForecastDateButton'> </span>",
        },
        {
          template: "<span id='cancelForecastDateButton'> </span>",
        },
      ],
    })
  $('#startDateToolbar')
    .css('width', '99.85%')
    .kendoToolBar({
      items: [
        {
          template: "<h5 style='font-weight:bold; padding-right:10px;'>From: </h5>",
        },
        {
          template: "<select id='startDateDropDownList' style ='width:100px;'></select>",
        },
        {
          template:
            "<h5 style='font-weight:bold; padding-right:10px; padding-left:4px;'>Number of Periods: </h5>",
        },
        {
          template: "<input id='suggestedTotalPeriods' style='width: 50px;'> </>",
        },
      ],
    })

  function getDate(initDate) {
    let date = initDate
    while (invalidForecastDates.indexOf(kendo.toString(date, 'yyyy-MM-dd')) >= 0) {
      date = new Date(date.setDate(date.getDate() + 1))
    }

    return date
  }

  function createStartDateData(forecastDate) {
    let startDateData = []
    let forecastYear = forecastDate.getFullYear()
    let forecastMonth = forecastDate.getMonth() + 1
    let forecastDateText = kendo.toString(forecastDate, 'yyyy-MM-dd')
    let testEnOfMonth = kendo.toString(new Date(forecastYear, forecastMonth, 0), 'yyyy-MM-dd')
    let isEndOfMonth = forecastDateText === testEnOfMonth
    if (isEndOfMonth) {
      forecastMonth = forecastDate.getMonth() + 2
    }
    for (let i = forecastMonth; i <= forecastMonth + 12; i++) {
      startDateData.push({
        StartDate: kendo.toString(new Date(forecastYear, i, 0), 'yyyy-MM-dd'),
        StartDateText: kendo.toString(new Date(forecastYear, i, 0), 'MMM-yyyy'),
      })
    }
    return startDateData
  }

  let forecastDatePicker = $('#forecastDatePicker')
    .kendoDatePicker({
      format: 'yyyy-MM-dd',
      dates: invalidForecastDates, //passing the disabledDays array to the template
      disableDates: function(date) {
        let selectedDate = kendo.toString(date, 'yyyy-MM-dd')
        let dates = invalidForecastDates
        if (selectedDate && dates.indexOf(selectedDate) >= 0) {
          return true
        } else {
          return false
        }
      },
      change: function() {
        let selectedDate = kendo.toString(this.value(), 'yyyy-MM-dd')
        let dates = this.options.dates
        if (dates.indexOf(selectedDate) >= 0) {
          this.value(null) //clear the selected value
          return
        }
        startDateDropDownList.dataSource.data(createStartDateData(this.value()))
        startDateDropDownList.select(0)
      },
      month: {
        // template for dates in month view
        content:
          '# if (data.dates.includes(kendo.toString(data.date,"yyyy-MM-dd"))) { #' +
          '<div class="disabledDay">#= data.value #</div>' +
          '# } else { #' +
          '#= data.value #' +
          '# } #',
      },
      open: function() {
        $('.disabledDay')
          .parent()
          .removeClass('k-link') //removing this class makes the day unselectable
        $('.disabledDay')
          .parent()
          .removeAttr('href') //this removes the hyperlink styling
      },
    })
    .data('kendoDatePicker')

  minDate = kendo.parseDate(minDate)
  forecastDatePicker.value(getDate(minDate))

  let data = createStartDateData(forecastDatePicker.value() || new Date())
  startDateDropDownList = $('#startDateDropDownList')
    .kendoDropDownList({
      dataTextField: 'StartDateText',
      dataValueField: 'StartDate',
      dataSource: data,
      index: 0,
    })
    .data('kendoDropDownList')

  let suggestedTotalPeriodsNumericTextBox = $('#suggestedTotalPeriods')
    .kendoNumericTextBox({
      format: 'n0',
      min: 1,
      spinners: false,
      step: 0,
    })
    .data('kendoNumericTextBox')

  let total = nbPeriods == null ? 12 : nbPeriods < 1 ? 12 : nbPeriods
  suggestedTotalPeriodsNumericTextBox.value(total)

  $('#addForecastDateButton').kendoButton({
    icon: 'k-icon k-i-check-outline',
    click: function() {
      addForecastDate()
    },
  })

  $('#cancelForecastDateButton').kendoButton({
    icon: 'k-icon k-i-cancel',
    click: function() {
      kendoWindow.close()
    },
  })

  function addForecastDate() {
    if (options.divisionId) {
      axios
        .post(url.action('createForecastDate', 'DivisionForecast'), {
          clientId: options.clientId,
          flowTypeId: options.flowTypeId,
          divisionId: options.divisionId,
          ccy: options.ccy,
          forecastDate: kendo.toString(forecastDatePicker.value(), 'yyyy-MM-dd'),
          startDate: startDateDropDownList.value(),
          nbOfPeriods: suggestedTotalPeriodsNumericTextBox.value(),
        })
        .then(function(result) {
          if (!result.data.errors) {
            ee.$emit('save')
            kendoWindow.close()
          }
        })
    } else if (options.ccyPairId) {
      axios
        .post(url.action('createCashFlowDivisionForecastDate', 'DivisionForecast'), {
          clientId: options.clientId,
          flowTypeId: options.flowTypeId,
          ccyPairId: options.ccyPairId,
          exposureCcy: options.exposureCcy,
          forecastDate: kendo.toString(forecastDatePicker.value(), 'yyyy-MM-dd'),
          startDate: startDateDropDownList.value(),
          nbOfPeriods: suggestedTotalPeriodsNumericTextBox.value(),
        })
        .then(function(result) {
          if (!result.data.errors) {
            ee.$emit('save')
            kendoWindow.close()
          }
        })
    } else {
      axios
        .post(url.action('createFxCcyRateForecastDate', 'FxRate'), {
          clientId: options.clientId,
          marketId: -1, //ToDo: Market?
          forecastDate: kendo.toString(forecastDatePicker.value(), 'yyyy-MM-dd'),
          startDate: startDateDropDownList.value(),
          nbOfPeriods: suggestedTotalPeriodsNumericTextBox.value(),
        })
        .then(function(result) {
          if (!result.data.errors) {
            ee.$emit('save')
            kendoWindow.close()
          }
        })
    }
  }

  kendoWindow.center().open()
  kendo.resize($('.k-widget'))
}

export default {
  openFxRateForecast: function(clientId, invalidForecastDates, nbPeriods) {
    axios
      .get(url.action('suggestFxCcyRateForecast', 'fxRate'), {
        params: {
          clientId: clientId,
        },
      })
      .then(function(minDate) {
        createControls(
          {
            clientId: clientId,
          },
          invalidForecastDates,
          nbPeriods,
          minDate.data,
        )
      })
  },
  openCashFlowDivisionForecast: function(
    clientId,
    flowTypeId,
    ccyPairId,
    exposureCcy,
    invalidForecastDates,
    nbPeriods,
  ) {
    axios
      .get(url.action('suggestCashFlowDivisionForecast', 'divisionForecast'), {
        params: {
          clientId: clientId,
          flowTypeId: flowTypeId,
          ccyPairId: ccyPairId,
        },
      })
      .then(function(minDate) {
        var options = {
          clientId: clientId,
          flowTypeId: flowTypeId,
          ccyPairId: ccyPairId,
          exposureCcy: exposureCcy,
        }
        createControls(options, invalidForecastDates, nbPeriods, minDate.data)
      })
  },
  openWindow: function(clientId, divisionId, flowTypeId, ccy, invalidForecastDates, nbPeriods) {
    axios
      .get(url.action('getLastClosedPeriodEndDate', 'DivisionForecast'), {
        params: {
          clientId: clientId,
          divisionId: divisionId,
          flowTypeId: flowTypeId,
          ccy: ccy,
        },
      })
      .then(function(minDate) {
        var options = {
          clientId: clientId,
          divisionId: divisionId,
          flowTypeId: flowTypeId,
          ccy: ccy,
        }
        createControls(options, invalidForecastDates, nbPeriods, minDate.data)
      })
  },
  onSaveChanges: function(callback) {
    ee.$on('save', callback)
  },
}
